/** La pone `vite.config.ts` al compilar; en `pnpm dev` vale "dev" y en los tests no existe. */
declare const __SIM_VERSION__: string | undefined;

/**
 * La huella de la simulacion de este cliente (ver
 * `packages/shared/scripts/simVersion.mjs`). Viaja en el `hello`: el servidor
 * rechaza con `CLOSE_OUTDATED` a quien no coincide con la suya.
 */
export const CLIENT_SIM_VERSION: string = typeof __SIM_VERSION__ === "string" ? __SIM_VERSION__ : "dev";
